import { render, staticRenderFns } from "./SocialMedia.vue?vue&type=template&id=e9368442&scoped=true&"
import script from "./SocialMedia.vue?vue&type=script&lang=js&"
export * from "./SocialMedia.vue?vue&type=script&lang=js&"
import style0 from "./SocialMedia.vue?vue&type=style&index=0&id=e9368442&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9368442",
  null
  
)

export default component.exports